export const breakpointColumnsObj = {
  default: 3,
  2500: 5,
  1700: 4,
  1360: 3,
  758: 2,
}

export const PRIVACY_URL =
  'https://scn7nr4axh9v.feishu.cn/wiki/XJlZwRBq1ijef0kUZWVcH5TDnch'
export const SERVICE_URL =
  'https://scn7nr4axh9v.feishu.cn/wiki/HRbkw7DNeijulVkTZHhcte0mn7d'
